@if (isBrowser) {
  <div class="page">
    <app-main-nav type="website"></app-main-nav>

    <app-hero
      appLazyLoad
      #intersection="intersection"
      [class.block]="!intersections.hero"
      [class.block--is-intersecting]="intersections.hero"
      (isIntersecting)="isIntersecting($event, 'hero')"
      [isContinuous]="true"
    ></app-hero>

    <app-key-features
      appLazyLoad
      [class.block]="!intersections.keyFeatures"
      [class.block--is-intersecting]="intersections.keyFeatures"
      (isIntersecting)="isIntersecting($event, 'keyFeatures')"
      [isContinuous]="true"
    ></app-key-features>

    <section class="section">
      <div class="website-container">
        <app-industries appLazyLoad
                        class="industries-wrapper"
                        [class.block]="!intersections.industries"
                        [class.block--is-intersecting]="intersections.industries"
                        (isIntersecting)="isIntersecting($event, 'industries')"></app-industries>
      </div>
    </section>

    <section class="section"
             appLazyLoad
             [class.block]="!intersections.ai"
             [class.block--is-intersecting]="intersections.ai"
             (isIntersecting)="isIntersecting($event, 'ai')"
    >
      <div class="website-container">
        <div class="section-content">
          <div class="section-column section-column-text section-column-reverted">
            <h3 class="h3">{{ 'WEBSITE.SCREENING.TITLE' | translate }}</h3>

            <p>{{ 'WEBSITE.SCREENING.TEXT' | translate }}</p>

            <app-button
              class="ai-button"
              [config]="{
                view: 'outlined',
                label: 'COMMON.LEARN_MORE'
              }"
              [routerLink]="['/features/ai']"
            >
            </app-button>
          </div>

          <div class="section-column">
            <img class="section-image"
                 ngSrc="/assets/img/website/screening_home.png"
                 width="1320"
                 height="982"
                 alt="Application screening"
            >
          </div>
        </div>
      </div>
    </section>

    <app-customers
      appLazyLoad
      class="customers-wrapper"
      [class.block]="!intersections.customers"
      [class.block--is-intersecting]="intersections.customers"
      (isIntersecting)="isIntersecting($event, 'customers')"
      [isContinuous]="true"
    ></app-customers>

    <app-benefits
      appLazyLoad
      [class.block]="!intersections.benefits"
      [class.block--is-intersecting]="intersections.benefits"
      (isIntersecting)="isIntersecting($event, 'benefits')"
      [isContinuous]="true"
    ></app-benefits>

    <app-nordic
      appLazyLoad
      [class.block]="!intersections.nordic"
      [class.block--is-intersecting]="intersections.nordic"
      (isIntersecting)="isIntersecting($event, 'nordic')"
      [isContinuous]="true"
    ></app-nordic>

    <app-trial
      appLazyLoad
      [class.block]="!intersections.trial"
      [class.block--is-intersecting]="intersections.trial"
      (isIntersecting)="isIntersecting($event, 'trial')"
      [isContinuous]="true"
    ></app-trial>

    <app-reviews
      [isShowCharacter]="true"
      appLazyLoad
      [class.block]="!intersections.reviews"
      [class.block--is-intersecting]="intersections.reviews"
      (isIntersecting)="isIntersecting($event, 'reviews')"
      [isContinuous]="true"
    ></app-reviews>

    <app-footer
      appLazyLoad
      [class.block]="!intersections.footer"
      [class.block--is-intersecting]="intersections.footer"
      (isIntersecting)="isIntersecting($event, 'footer')"
      [isContinuous]="true"
    ></app-footer>
  </div>
}
